Ext.ns('mx.comp');
// under admin
mx.comp.LoginForm = Ext.extend(mx.comp.FormPanel, {
    id: 'sl-login-form',
    name: 'login_form_container',
    url: mx.PATH + MXAT.API('auth/login'),
    labelWidth: 97,
    width: 270,
    y: 50,
    defaultType: 'textfield',
    buttonAlign: 'right',
    cls: 'mx-comp-loginform',
    border: false,
    method: 'POST',
    labels: {
        login: 'Login',
        password: 'Password',
        enter: 'Enter',
        remember: 'Remember me for 7 days',
    },

    handlers: {
        forgotPasswordForm: function() {
            var forgotPasswordWindow = new mx.app.widget.WindowForm({
                editable: true,
                title: 'Forgot password',
                width: 300,
                formClass: mx.app.widget.ForgotPasswordForm,
                labels: {
                    close: 'Close',
                    ok: 'Send new password',
                },
                initComponent: function() {
                    Ext.Window.prototype.initComponent.apply(this, arguments);

                    this.addButton(
                        {
                            text: this.labels.ok,
                            name: 'forgotPasswordWindow.btnOk',
                        },
                        function() {
                            if (!forgotPasswordWindow.form.getForm().isValid()) {
                                mx.Util.Msg.someFieldsAreWrong();
                                return;
                            }
                            var login = forgotPasswordWindow.form.loginField.getValue();
                            var element = this.container;
                            element.mask('Sending', 'x-mask-loading');
                            Ext.Ajax.request({
                                method: 'GET',
                                url: mx.PATH + MXAT.API('auth/remember'),
                                params: {
                                    login: login,
                                },
                                success: function(r) {
                                    forgotPasswordWindow.close();
                                    var json = Ext.util.JSON.decode(r.responseText);
                                    element.unmask();
                                    if (json.errors.length == 0) {
                                        Ext.Msg.alert(
                                            "<font face = 'Tahoma,Arial,sans-serif' size = '11px'>Password sent</font>",
                                            'The password has been sent to your email address'
                                        );
                                    } else {
                                        Ext.Msg.alert('Error', json.errors[0].message);
                                    }
                                },
                                failure: function(r) {
                                    var json = Ext.util.JSON.decode(r.responseText);
                                    element.unmask();
                                    if (json.errors.length > 0)
                                        Ext.Msg.alert(
                                            '<font face = "Tahoma,Arial,sans-serif" size = "11px">Error</font>',
                                            json.errors[0].message
                                        );
                                },
                            });
                            //this.close();
                        },
                        this
                    );

                    this.addButton(
                        {
                            text: this.labels.close,
                            name: 'forgotPasswordWindow.btnClose',
                        },
                        function() {
                            this.close();
                        },
                        this
                    );
                    this.add((this.form = new this.formClass(this.formClassConfig)));
                },
                listeners: {
                    ok: function() {
                        var login = forgotPasswordWindow.form
                            .getForm()
                            .findField('name')
                            .getValue();
                        Ext.Ajax.request({
                            method: 'GET',
                            url: mx.PATH + MXAT.API('auth/remember'),
                            params: {
                                login: login,
                            },
                            success: function(r) {
                                forgotPasswordWindow.close();
                                var json = Ext.util.JSON.decode(r.responseText);
                                if (json.errors.length == 0) {
                                    Ext.Msg.alert('Finished', 'The password has been sent to your email address');
                                } else {
                                    Ext.Msg.alert('Error', json.errors[0].message);
                                }
                            },
                            failure: function() {},
                        });
                    },
                },
            });
            forgotPasswordWindow.show();
        },
    },
    initComponent: function() {
        mx.comp.LoginForm.superclass.initComponent.call(this, arguments);

        var btnHandler = function() {
            Ext.Ajax.request({
                url: this.url,
                method: 'POST',
                success: this.success,
                failure: this.failure,
                scope: this,
                params: {
                    login: this.loginField.getValue(),
                    password: this.passwordField.getValue(),
                    remember: this.rememberMe.getValue(),
                    account: this.accountUrl.getValue(),
                },
            });
        };

        var fieldHandler = function(field, e) {
            if (e.getKey() == Ext.EventObject.ENTER) {
                btnHandler.call(this);
            }
        };

        this.loginField = new Ext.form.TextField({
            id: 'mx.app.page.Login.login',
            fieldLabel: this.labels.login,
            value: '',
            name: 'login',
            anchor: '100%',
            listeners: {
                render: function(field) {
                    field.focus(true, true);
                },
                specialkey: {
                    fn: fieldHandler,
                    scope: this,
                },
            },
        });

        this.passwordField = new Ext.form.TextField({
            id: 'mx.app.page.Login.password',
            fieldLabel: this.labels.password,
            value: '',
            name: 'password',
            inputType: 'password',
            anchor: '100%',
            msgTarget: 'under',
            style: 'background',
            listeners: {
                specialkey: {
                    fn: fieldHandler,
                    scope: this,
                },
            },
        });

        this.rememberMe = new Ext.form.Checkbox({
            id: 'mx.app.page.Login.remember',
            ctCls: 'mx-checkbox',
            border: false,
            checked: false,
            name: 'remember',
            hideLabel: true,
            boxLabel: this.labels.remember,
        });

        this.add(this.loginField, this.passwordField);

        this.add(this.rememberMe);

        this.add(
            (this.accountUrl = new Ext.form.Hidden({
                name: 'account',
                value: window.accountURL,
            }))
        );

        this.addButton({
            id: 'mx.app.page.Login.enter',
            text: this.labels.enter,
            handler: btnHandler,
            scope: this,
        });
    },
});
